<template>
  <div>
    <div class="page landscape">
      <Logo />
      <div class="background"></div>
      <div class="info">
        <div class="container">
          <!-- <center><h1>Ofertę przygotował</h1></center> -->

          <div class="flex">
            <div class="single-flex">
              <img
                src="https://i.picsum.photos/id/1/400/400.jpg"
                alt=""
                srcset=""
              />
            </div>
            <div class="single-flex trader">
              <!-- <h3>Ku ba</h3> -->
              <h3>{{ traderName }}</h3>
              <ul>
                <li>
                  Neadoo Digital
                </li>
                <li>
                  Email: jk@neadoo.eu
                </li>
                <li>
                  Tel. 697 978 797
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/Logo.vue'

export default {
  name: 'Trader',
  components: {
    Logo,
  },
  props: {
    traderName: {
      type: String,
      default: 'Kub',
    },
  },
  methods: {
    dynamic(key) {
      return new URLSearchParams(window.location.search).get(key)
    },
  },
  data: function () {
    return {
      traders: [
        {
          id: 1,
          name: 'Robert Starecki',
          phone: '+48 111 111 111 ',
          mail: 'rs@neadoo.eu',
          photo: '/traders/robert.jpg',
        },
        {
          id: 2,
          name: 'Krzysztof Marcinkowski',
          phone: '+48 222 222 222',
          mail: 'km@neadoo.eu',
          photo: '/traders/krzysztof.jpg',
        },
      ],
      checkedService: [],
    }
  },
}
</script>

<style scoped>
.page {
  background: url('/trader.jpg');
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  z-index: 0;
  /* text-transform: uppercase; */
}

.flex {
  display: flex;
  align-items: space-around;
  justify-content: center;
  margin-top: 50px;
  padding: 0 50px;
}

.single-flex {
  padding: 0 25px;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
li {
  text-justify: inter-word;
  margin: 0;
  padding: 0;
  text-align: justify;
  font-size: 24px;
}

.trader {
  display: flex;
  align-items: center;
  flex-flow: column wrap;
  margin-top: 100px;
}

h3 {
  font-size: 36px;
  text-align: center;
}

img {
  border: 3px solid #fff;
}
</style>
